(function ($) {
    function apply(elm, role) {
        var role = role.toLowerCase();

        switch (role) {
            case 'date':
                elm.datefield(elm.data('datefield'));
                break;

            case 'time':
                elm.timesuggest(elm.data('timesuggest'));
                break;

            case 'timespan':
                elm.chTimeSpan(elm.data('timespan'));
                break;

            case 'expanding':
                elm.expandingTextarea();
                break;

            case 'charcount':
                var allowed = parseInt(elm.attr('maxlength'));
                if (allowed) {
                    elm.charCount({
                        counterContainer: $('<span>')
                            .addClass('ch-charcount')
                            .prependTo(elm.closest('.form-group')),
                        allowed: allowed,
                        warning: Math.min(50, allowed / 3),
                        hide: true
                    });
                }
                break;

            case 'token':
                // see engine.getConfig() for supported token-types
                elm.chTokenField(elm.data('token-type'), elm.data('token-allow-new'))
                break;

            case 'tokenmodal':
                var chTokenField = $(elm.data('token-input'));
                elm.chTokenModal(chTokenField, chTokenField.data('token-type'));
                break;

            case 'typeahead':
                // https://github.com/twitter/typeahead.js/blob/master/doc/jquery_typeahead.md
                elm.chTypeahead({
                    type: elm.data('typeahead-type'),
                    submit: elm.attr('data-typeahead-submit') !== undefined,
                    idField: elm.attr('data-typeahead-idfield')
                });
                break;

            case 'typeahead-id':
                $(elm.data('typeahead-field')).on('typeahead:select', function (e, token) {
                    elm.val(token.value);
                    elm.trigger("change");
                });
                break;

            case 'submit-readonly':
                elm.on('submit', function () {
                    var validator = elm.data('validator');
                    if (!validator || validator.form()) {
                        elm.find('input,select,textarea').attr('readonly', true);
                        elm.find('button').attr('disabled', true);
                    }
                });
                break;

            case 'accordion-toggle':
                elm.chToggleAccordion();
                break;

            case 'selectall':
                elm.on('click', function () {
                    $($(this).data('target')).each(function () {
                        this.checked = true
                    })
                });
                break;

            case 'selectnone':
                elm.on('click', function () {
                    $($(this).data('target')).each(function () {
                        this.checked = false
                    })
                });
                break;

            case 'servicesubmit':
                elm.chServiceSubmit();
                break;

            default:
                throw 'data-chrole="' + field + '" not supported';
        }
    }

    $(function() {
        $('[data-chrole]').each(function () {
            var elm = $(this);
            $.each(elm.data('chrole').split(' '), function (i, role) {
                apply(elm, role);
            })
        });
    })
}($));
